import React from 'react';
import { Link } from 'react-router-dom';
import styles from './index.module.scss';

export default function Logo(props) {
  return (
    <Link to="/Dashboard" style={{ ...props.style }} className={styles.logoStyle}>
      <img height={28} width={28} src="./favicon.png" className={styles.userAvatar} alt="logo" />
      {!props.collapsed && <span className={styles.title}>采购管理</span>}
    </Link>
  );
}
